import React, { useState, useEffect, useRef } from "react";
import { useQuery } from "react-query";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { DropdownMenu } from "../sharedComponents";
import { getTotalLiveEventsByRange } from "../actions";

const EventBroadcasts = ({ clientID }) => {
  const [dateRange, setDateRange] = useState("This Month");

  const {
    isLoading,
    data: eventsBroadcasted,
    refetch,
  } = useQuery(`eventsBroadcasted`, () =>
    getTotalLiveEventsByRange({
      clientID,
      range: dateRange.split(" ")[1].toLowerCase(),
    })
  );

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    refetch();
  }, [dateRange]);

  return (
    <>
      <Box display="flex" justifyContent="space-between" sx={{ my: 1 }}>
        <Typography variant="h3" sx={{ ml: 0.12 }}>
          Event Broadcasts
        </Typography>

        <DropdownMenu
          currentOption={dateRange}
          setCurrentOption={setDateRange}
          optionsArr={["This Week", "This Month", "This Year"]}
        />
      </Box>

      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={eventsBroadcasted}
          margin={{
            top: 5,
            left: 5,
            right: 5,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="2 2" />
          <XAxis dataKey="dateLabel" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="Number of Events"
            stroke="rgb(28,69,102)"
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </>
  );
};

export default EventBroadcasts;
